import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/themeThree/K65logo.png'


const _hoisted_1 = { class: "notice_container" }
const _hoisted_2 = { class: "titleHead" }
const _hoisted_3 = ["innerHTML"]

import CustomHeader from '@/components/common/customHeader.vue';



export default /*@__PURE__*/_defineComponent({
  __name: 'errorNotice',
  emits: ['goToHome'],
  setup(__props, { emit: __emit }) {

const emits = __emit

const goToHome = () => {
    emits('goToHome')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "back-link",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
    }, _cache[1] || (_cache[1] = [
      _createElementVNode("span", { class: "chevron" }, "❮", -1)
    ])),
    _cache[2] || (_cache[2] = _createElementVNode("img", {
      src: _imports_0,
      alt: ""
    }, null, -1)),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('notice.updateNotification')), 1),
    _createElementVNode("div", {
      innerHTML: _ctx.$t('notice.contentText')
    }, null, 8, _hoisted_3)
  ]))
}
}

})